/**
 * Tipos comunes de dominio: paginación por cursor, timestamps, envelopes.
 */
import { z } from 'zod';

/** ISO-8601 UTC. En BD siempre `timestamptz`; se muestra en la zona del local. */
export const TimestampSchema = z.string().datetime({ offset: true });

export const CursorSchema = z.string().min(1).max(512).optional();

export const PageQuerySchema = z.object({
  cursor: CursorSchema,
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
    total: z.number().int().nonnegative().optional(),
  });
}

/** Estado genérico de un recurso con ciclo de vida auditable. */
export const EntityMetaSchema = z.object({
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema.optional(),
  createdBy: z.string().nullable(),
});
export type EntityMeta = z.infer<typeof EntityMetaSchema>;
